export function onCtrlEnter(e: React.KeyboardEvent<HTMLFormElement>, fn: () => void) {
  if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
    e.stopPropagation()
    e.preventDefault()
    fn()
  }
}
